import { resolveRole } from "@/utils/roles";
import AccountDropdown from "@/components/account-dropdown";
import { adminNavItems, navItems } from "@/config/nagivation/desktop-routes-config";
import { useUser } from "@clerk/react";
import { Button, Card } from "@heroui/react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SideNav = () => {
  const { user } = useUser();
  const isAdmin = resolveRole(user) === "admin";
  const location = useLocation();
  const navigate = useNavigate();

  // const { handleRoleSwitch, currentRole } = context;

  return (
    <Card className="border-r h-full p-4 min-w-[200px] bg-background border">
      <Card.Header className="flex-row items-center gap-2">
        <div className="rounded-full text-background">
          <img src="/fav.png" width={48} alt="" />
        </div>
        <div className="font-extrabold text-lg">Loopp</div>
      </Card.Header>
      <Card.Content className="flex flex-col items-start gap-4">
        <div className="flex flex-col items-start w-full">
          {navItems.map((item, i) => {
            const Icon = item.icon;
            const isActive = item.route === location.pathname;
            return (
              <Button
                variant={isActive ? "primary" : "ghost"}
                onPress={() => navigate(item.route)}
                className={"gap-4 justify-start h-10 rounded-2xl"}
                fullWidth
                key={item.key}
              >
                <Icon />
                <span>{item.label}</span>
              </Button>
            );
          })}
        </div>

        <div className="h-px bg-separator w-full" />
        {isAdmin && <span className="text-[10px] text-muted uppercase font-semibold">Admin Routes</span>}
        <div className="flex flex-col items-start w-full">
          {(isAdmin ? adminNavItems : []).map((item, i) => {
            const Icon = item.icon;
            const isActive = item.route === location.pathname;
            return (
              <Button
                variant={isActive ? "primary" : "ghost"}
                onPress={() => navigate(item.route)}
                className={"gap-4 justify-start h-10 rounded-2xl"}
                fullWidth
                key={item.key}
              >
                <Icon />
                <span>{item.label}</span>
              </Button>
            );
          })}
        </div>
      </Card.Content>

      <Card.Footer>
        <AccountDropdown />
      </Card.Footer>
    </Card>
  );
};

export default SideNav;
